import Typography from "@mui/material/Typography";
import React from "react";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import ListItemText from "@mui/material/ListItemText";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Grid from "@mui/material/Grid";
import AvatarIcon from "../assets/icons/avatar.svg";
import WalletIcon from "../assets/icons/wallet_icon.svg";
import AddCardIcon from "@mui/icons-material/AddCard";
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import {AVATAR_BASE_URL_API, BASE_URL_API} from "../Const";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MuiAlert from "@mui/material/Alert";
import {Snackbar} from "@mui/material";
import {BackButton, BottomMenu} from './HookUtils'
import IconButton from "@mui/material/IconButton";
import L from 'leaflet';
import customMarkerIconUrl from '../assets/icons/current-location.png'; // This must be inside src

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const customLocationIcon = L.icon({
    iconUrl: customMarkerIconUrl,
    iconSize: [40, 40],      // Size of the icon
    iconAnchor: [20, 40],    // Point of the icon which corresponds to marker's location
    popupAnchor: [0, -40]    // Point from which the popup should open relative to the iconAnchor
});

export class ProfileComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: null,
            name: null,
            address: null,
            postalcode: null,
            openSnackbar: false,
            message: "",
            snackbarType: "success",
            lat: null,
            lng: null,
            showMapModal: false,
        };

        this._map = null;
        this._marker = null;
    }

    componentDidMount() {
        this.getUserData()
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.showMapModal && this.state.showMapModal) {
            setTimeout(() => {
                const L = require('leaflet');
                const lat = this.state.lat || 35.6892;
                const lng = this.state.lng || 51.3890;

                if (this._map) {
                    this._map.remove(); // Remove previous map if exists
                }

                this._map = L.map('leafletMap').setView([lat, lng], 13);

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; OpenStreetMap contributors'
                }).addTo(this._map);

                this._marker = L.marker([lat, lng], {icon: customLocationIcon}).addTo(this._map);

                this._map.on('click', (e) => {
                    const {lat, lng} = e.latlng;
                    this._marker.setLatLng([lat, lng]);
                    this.setState({lat, lng});
                });
            }, 200);
        }
    }

    handleShowCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;

                this.setState({lat, lng}, () => {
                    if (this._map && this._marker) {
                        this._map.setView([lat, lng], 15);
                        this._marker.setLatLng([lat, lng]);
                    }
                });
            }, (err) => {
                alert("موقعیت شما قابل دریافت نیست.");
                console.error(err);
            });
        } else {
            alert("مرورگر شما از مکان‌یاب پشتیبانی نمی‌کند.");
        }
    }

    getUserData() {
        fetch(BASE_URL_API + 'user', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                if (results.code === "200") {
                    this.setState({
                        userData: results.data,
                        name: results.data.name,
                        address: results.data.address,
                        postalcode: results.data.postalcode,
                        lat: results.data.lat,
                        lng: results.data.lng
                    })
                }
            })
    }

    render() {
        const handleCloseSnackbar = () => {
            this.setState({openSnackbar: false})
        }

        const onUpdateProfileClicked = () => {
            fetch(BASE_URL_API + 'user', {
                method: 'PUT',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: this.state.name,
                    address: this.state.address,
                    postalcode: this.state.postalcode,
                    lat: this.state.lat,
                    lng: this.state.lng
                })
            })
                .then(response => response.json())
                .then(result => {
                    if (result.code === "200") {
                        this.getUserData()
                        this.setState({
                            userData: result.data,
                            openSnackbar: true,
                            message: "حساب کاربری با موفقیت ویرایش شد.",
                            snackbarType: "success"
                        })
                    } else {
                        this.setState({
                            openSnackbar: true,
                            message: result.message,
                            snackbarType: "error"
                        })
                    }
                });
        };

        return (
            <React.Fragment>
                <AppBar style={{background: 'rgba(238,238,238,0.3)'}}>
                    <ToolbarMui>
                        <IconButton style={{color: 'black'}} size="large">
                            <AccountCircleIcon/>
                        </IconButton>
                        <ListItemText align="center">
                            <strong style={{fontSize: 18, color: 'black'}}>پروفایل</strong>
                        </ListItemText>
                        <BackButton/>
                    </ToolbarMui>
                </AppBar>

                <div style={{width: '100%', marginTop: 72}} align="center">
                    <Grid container justifyContent="center">
                        {
                            !this.state.userData ? null : (
                                <React.Fragment>
                                    <Grid item xs={12}>
                                        <img
                                            alt="avatar"
                                            src={this.state.userData.picture ? AVATAR_BASE_URL_API + this.state.userData.picture.url : AvatarIcon}
                                            style={{borderRadius: '50%', width: 96, height: 96, margin: 8}}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Typography style={{fontWeight: 'bold', fontSize: 18}}>
                                            شماره تلفن: {this.state.userData.phone}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} style={{marginBottom: 32}}>
                                        <img alt="wallet" src={WalletIcon}
                                             style={{width: 18, height: 18, verticalAlign: 'middle'}}/>
                                        <Typography display="inline"
                                                    style={{marginLeft: 8, fontWeight: 'bold', color: 'green'}}>
                                            موجودی: {this.state.userData.wallet}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={1} style={{marginTop: 35}}><AddCardIcon/></Grid>

                                    <Grid item xs={11} style={{marginTop: 18,paddingLeft: 35}}>
                                        <TextField
                                            fullWidth
                                            style={{marginLeft: 35}}
                                            defaultValue={this.state.name}
                                            placeholder="نام و نام خانوادگی"
                                            onChange={e => this.setState({name: e.target.value})}
                                        />
                                    </Grid>


                                    <Grid item xs={1} style={{marginTop: 35}}><WysiwygIcon/></Grid>

                                    <Grid item xs={11} style={{marginTop: 18,paddingLeft: 35}}>
                                        <TextField
                                            fullWidth
                                            defaultValue={this.state.postalcode}
                                            placeholder="کد پستی"
                                            onChange={e => this.setState({postalcode: e.target.value})}
                                        />
                                    </Grid>

                                    <Grid item xs={1} style={{marginTop: 35}}><AddHomeWorkIcon/></Grid>

                                    <Grid item xs={11} style={{marginTop: 18,paddingLeft: 35}}>
                                        <TextField
                                            fullWidth
                                            defaultValue={this.state.address}
                                            placeholder="آدرس"
                                            onChange={e => this.setState({address: e.target.value})}
                                        />
                                    </Grid>

                                    <Grid item xs={1} style={{marginTop: 35}}><EditLocationAltIcon/></Grid>

                                    <Grid item xs={11} style={{marginTop: 18,paddingLeft: 35}}>
                                        <TextField
                                            fullWidth
                                            onClick={() => this.setState({showMapModal: true})}
                                            placeholder="انتخاب موقعیت روی نقشه"
                                        />
                                    </Grid>

                                    <Grid item xs={6} style={{marginTop: 40}}>

                                        <Button
                                            variant="contained"
                                            onClick={onUpdateProfileClicked}
                                            style={{backgroundColor: "#FF1744", color: "white", width: '50%',}}
                                        >
                                            ویرایش
                                        </Button>
                                    </Grid>


                                </React.Fragment>
                            )
                        }
                    </Grid>

                    <Snackbar open={this.state.openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                        <Alert onClose={handleCloseSnackbar} severity={this.state.snackbarType}>
                            {this.state.message}
                        </Alert>
                    </Snackbar>
                </div>

                {/* Leaflet Modal */}
                {this.state.showMapModal && (
                    <div
                        onClick={() => this.setState({showMapModal: false})}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            backgroundColor: 'rgba(0,0,0,0.7)',
                            zIndex: 9999,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()} // prevent modal close when clicking inside
                            style={{
                                width: '90%',
                                height: '75vh',
                                backgroundColor: '#fff',
                                borderRadius: 8,
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'hidden'
                            }}
                        >
                            <div id="leafletMap" style={{flex: 1}}></div>


                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: 12,
                                borderTop: '1px solid #ccc',
                                backgroundColor: '#f8f8f8'
                            }}>
                                <Button
                                    onClick={this.handleShowCurrentLocation}
                                    variant="outlined"
                                    color="info"
                                >
                                    موقعیت من
                                </Button>

                                <div style={{display: 'flex', gap: '12px'}}>
                                    <Button
                                        onClick={() => this.setState({showMapModal: false})}
                                        variant="outlined"
                                        color="secondary"
                                    >
                                        بستن
                                    </Button>

                                    <Button
                                        onClick={() => {
                                            if (this.state.lat && this.state.lng) {
                                                this.setState({showMapModal: false});
                                            } else {
                                                alert('لطفاً روی نقشه یک نقطه انتخاب کنید!');
                                            }
                                        }}
                                        variant="contained"
                                        color="primary"
                                    >
                                        انتخاب موقعیت
                                    </Button>
                                </div>
                            </div>

                        </div>
                    </div>
                )}


                <BottomMenu/>
            </React.Fragment>
        );
    }
}
